/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const error404PageStyle = {
  teaserImage: {
    height: "auto",
    margin: "0 auto",
    display: "block",
    maxWidth: { sx: "250px", md: "350px" },
  },
  container: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      marginTop: "5rem",
    },
  }),
  button: {
    marginTop: "20px",
    width: "300px",
  },
};

export default error404PageStyle;
